var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';

export class I18N extends Component {
  render() {
    const dictionary = this.props.dictionaries.toJS().find((d) => d.locale === this.props.locale) || {
      values: {}
    };
    let text = this.props.children;
    text = dictionary.values[text] || text;
    return /*#__PURE__*/_jsx("span", {}, void 0, text);
  }
}







const mapStateToProps = ({ locale, dictionaries }) => ({ locale, dictionaries });

export default connect(mapStateToProps)(I18N);